import { render, staticRenderFns } from "./HandoverUpload.vue?vue&type=template&id=8a7d8b62&scoped=true"
import script from "./HandoverUpload.vue?vue&type=script&lang=js"
export * from "./HandoverUpload.vue?vue&type=script&lang=js"
import style0 from "./HandoverUpload.vue?vue&type=style&index=0&id=8a7d8b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7d8b62",
  null
  
)

export default component.exports